import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatabaseUpstreamDatasourcesWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatabaseUpstreamDatasourcesWithoutPersonalSpaceQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: { id: $databaseId }) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
